module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM20 28H4V4h16v24zm-8.876-6.246c.446.426.876.286.876-.316V18h5a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-5v-3.438c0-.602-.398-.742-.844-.318l-4.8 4.986c-.446.426-.38 1.114.06 1.54l4.708 4.984z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/slide-in-left-1.js
// module id = 1416
// module chunks = 14